import { render } from "./ThemeSwatch.vue?vue&type=template&id=2d3969ec&scoped=true"
import script from "./ThemeSwatch.vue?vue&type=script&lang=js"
export * from "./ThemeSwatch.vue?vue&type=script&lang=js"

import "./ThemeSwatch.vue?vue&type=style&index=0&id=2d3969ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3969ec"]])

export default __exports__